// Error handler for Webflow scripts and other JavaScript errors

export const handleWebflowErrors = () => {
  // Override console.error to catch and handle Webflow errors
  const originalError = console.error;
  console.error = (...args) => {
    // Check if it's a Webflow error
    if (args[0] && typeof args[0] === 'string' && args[0].includes('webflow')) {
      console.warn('Webflow script error caught and handled:', ...args);
      return; // Don't show the error
    }
    // Show other errors normally
    originalError.apply(console, args);
  };

  // Global error handler
  window.addEventListener('error', (event) => {
    if (event.filename && event.filename.includes('webflow')) {
      event.preventDefault();
      console.warn('Webflow error prevented:', event.error);
    }
  });

  // Unhandled promise rejection handler
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.toString().includes('webflow')) {
      event.preventDefault();
      console.warn('Webflow promise rejection handled:', event.reason);
    }
  });
};

// Initialize error handling
export const initErrorHandling = () => {
  handleWebflowErrors();
  
  // Additional error handling for form submissions
  window.addEventListener('error', (event) => {
    // Don't let Webflow errors break form functionality
    if (event.filename && event.filename.includes('webflow')) {
      event.preventDefault();
      event.stopPropagation();
    }
  });
};
